export const ITINERARY_NOT_FOUND: RegExp = /itinerary not found/i;
